module.exports = __webpack_public_path__ + "img/carIcon.eac6dfeb.png";